import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import AzureSubscriptionCSP from "../../../models/csp/AzureSubscriptionCSP";
import SubscriptionCSP from "../../../models/csp/SubscriptionCSP";
import azureSubscriptionService from "../../../services/csp/azureSubscriptionService";
import subscriptionService from "../../../services/csp/subscriptionService";
import { RootState } from "../../index";

const namespaced = true;

interface AzureSubscriptionState {
  azureSubscriptions: AzureSubscriptionCSP[];
}

const state: AzureSubscriptionState = {
  azureSubscriptions: []
};

const mutations: MutationTree<AzureSubscriptionState> = {
  setAzureSubscriptions(state, azSubs: AzureSubscriptionCSP[]) {
    state.azureSubscriptions = azSubs;
  }
};

const actions: ActionTree<AzureSubscriptionState, RootState> = {
  async loadAzureSubscriptionsCSP({ commit }, customerId: string) {
    const azureSubscriptions: AzureSubscriptionCSP[] = [];
    const azPlans: SubscriptionCSP[] =
      await subscriptionService.methods.getAzurePlanIdsByTenantId(customerId);
    for (const azPlan of azPlans) {
      const azSubs: AzureSubscriptionCSP[] =
        await azureSubscriptionService.methods.getAzureSubscriptionsCSP(
          customerId,
          azPlan.getId
        );
      azureSubscriptions.push(...azSubs);
    }
    commit("setAzureSubscriptions", azureSubscriptions);
  }
};

const getters: GetterTree<AzureSubscriptionState, RootState> = {
  getAzureSubscriptionsCSPByAzurePlanId:
    state =>
    (azPlanId: string): AzureSubscriptionCSP[] => {
      return state.azureSubscriptions.filter(
        azSub => azSub.getAzurePlanId === azPlanId
      );
    }
};

export const azureSubscriptionModuleCSP: Module<
  AzureSubscriptionState,
  RootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
